import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AddEditSubscriptionComponent } from './add-edit-subscription/add-edit-subscription.component';
import { RenewSubscriptionsComponent } from './renew-subscriptions/renew-subscriptions.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { SendEmailsComponent } from 'src/app/manufacturer/sponsoring/send-emails/send-emails.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-mobile-app-subscriptions',
    templateUrl: './mobile-app-subscriptions.component.html',
    styleUrls: ['./mobile-app-subscriptions.component.scss'],
    standalone: false
})
export class MobileAppSubscriptionsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  subscriptionsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    filter: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    filter: null
  };
  searchValue = "";
  showSelect = false;
  selectAll = false;
  allSelected = false;
  selectedNames = new Array<any>();
  selected = 'used';

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private exportService: ExportService
            ) {
                this.showSearch = false;
                this.userID = this.authService.getUserData().id;
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.selected = params.filter ? params.filter : null;
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                    this.searchValue =  params.searchValue ? params.searchValue : "";
                  }
                  this.getSubscriptions();
                });
              }

  ngOnInit(): void {
    this.utils.setTitle('Mobile Subscriptions');
    this.utils.screenTitle.emit({firstTitle: 'Subscriptions', firstRoute: '/mobile-app-subscriptions'});
    this.searchForm = new FormGroup({
      sponsorSearch: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('sponsorSearch')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  openAddSubscription() {
    const dialogRef = this.dialog.open(AddEditSubscriptionComponent, {disableClose: true,
    data: {
      type: 'Add',
    }});
    dialogRef.afterClosed().subscribe((newSubscriptions) => {
      if (newSubscriptions) {
        this.getSubscriptions();
        if(newSubscriptions.addAnother){
          this.openAddSubscription();
        }
      }
      // if (newPromotions && newPromotions.length > 0) {
      //   this.totalSize = this.totalSize + newPromotions.length;
      //   newPromotions.forEach(element => {
      //     this.promotionsList.unshift(element);
      //   });
      //   if (this.promotionsList.length > this.pageSize) {
      //     this.promotionsList.splice(this.pageSize, this.promotionsList.length = this.pageSize);
      //   }
      // }
    });
  }

  filterChange(value: any) {
    this.selected = value;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, filter: this.selected};
      this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
  }

  sendEmails() {
    if (this.selectedNames.length > 0) {
      const dialogRef = this.dialog.open(SendEmailsComponent,
        {disableClose: true, width: '400px', data: {namesList: this.selectedNames}});
      dialogRef.afterClosed().subscribe(() => {
      this.showSelect = false;
      this.setAll(false);
    });
    }
  }

  sendEmail(item: any) {
      const dialogRef = this.dialog.open(SendEmailsComponent,
        {disableClose: true, width: '400px', data: {namesList: [item]}});
      dialogRef.afterClosed().subscribe(() => {
      this.showSelect = false;

    });
  }

  toggleSelect() {
    this.selectedNames = [];
    this.showSelect = !this.showSelect;
  }

  setAll(checked: boolean) {
    this.allSelected = checked;
    this.selectAll = checked;

    if (checked) {
      this.selectedNames = [...this.subscriptionsList];
    } else {
      this.selectedNames = [];
    }
  }

  onCheckChange(item: any, checked: boolean) {
    if (checked) {
      this.selectedNames.push(item);
    } else {
      this.selectedNames = this.selectedNames.filter(i => i !== item);
    }

    this.allSelected = this.selectedNames.length === this.subscriptionsList.length;
    this.selectAll = this.allSelected;
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, filter: this.selected};
    this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.subscriptionsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('sponsorSearch')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('sponsorSearch')?.setValue(this.searchValue, { emitEvent: false });

    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, filter: this.selected};
      this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('sponsorSearch')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      filter: this.selected
    };
    this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
  }

  delete(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'subscription',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('distributor/DeleteSalesRepresentative/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.subscriptionsList.forEach( (users, index) => {
                if (users.id === id) {
                  this.subscriptionsList.splice(index, 1);
                  if (this.subscriptionsList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, filter: this.selected};
                    this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
                  } else {
                    this.getSubscriptions();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Subscription deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  renew(id: any) {
    const dialogRef = this.dialog.open(RenewSubscriptionsComponent, {disableClose: true,
      data: {
        type: 'Edit',
        id
      }});
    dialogRef.afterClosed().subscribe((newSubscriptions) => {
      this.getSubscriptions();
    });
  }

  edit(id: any, subscription: any) {
    const dialogRef = this.dialog.open(AddEditSubscriptionComponent, {disableClose: true,
    data: {
      type: 'Edit',
      id,
      subscription
    }});
    dialogRef.afterClosed().subscribe((newSubscriptions) => {
      if (newSubscriptions) {
        this.getSubscriptions();
      }
      // if (newPromotions && newPromotions.length > 0) {
      //   this.totalSize = this.totalSize + newPromotions.length;
      //   newPromotions.forEach(element => {
      //     this.promotionsList.unshift(element);
      //   });
      //   if (this.promotionsList.length > this.pageSize) {
      //     this.promotionsList.splice(this.pageSize, this.promotionsList.length = this.pageSize);
      //   }
      // }
    });
  }

  getSubscriptions() {
      this.dataService.get('distributor/RetrieveSalesRepresentatives/' +
      parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&filter=' + this.selected).then((data: any) => {
        if (data.statusCode === 200) {
          this.subscriptionsList = [];
          const promotionsData = data.data.records;
          this.totalSize = data.data.count;
          promotionsData.forEach((promotionData: any) => {
            this.subscriptionsList.push(promotionData);
          });
          if (promotionsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, filter: this.selected};
            this.router.navigate(['/mobile-app-subscriptions'], { queryParams: this.queryParams });
          }
        }
      });
  }

  diffDays(expiryDate:any): any{
    if(expiryDate === 'Infinity'){
      return expiryDate;
    }
    else {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date();
      const secondDate = new Date(expiryDate);
      if(secondDate<firstDate){
        return '.';
      }else {
        return Math.round(Math.abs(((+firstDate) - (+secondDate)) / oneDay)) + ' Days Left';
      }
    }
  }

  exportDistributerMobileAppSubscriptions(fileTypeId: number) {
    this.exportService.exportFile(`distributor/ExportSalesRepresentatives/${this.userID}`, fileTypeId, this.searchValue, 'mobileAppSubscriptions' );
  }
}
